import { useEffect, useState } from 'react';

const navLinks = [
  { href: '#featured', label: '热门推荐' },
  { href: '#ranking', label: '排行榜' },
  { href: '#latest', label: '最新大片' },
  { href: '#genres', label: '分类找片' },
  { href: '#guide', label: '选片指南' },
  { href: '#faq', label: '常见问题' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed left-0 top-0 z-50 w-full transition-colors duration-300 ${
        scrolled || menuOpen
          ? 'border-b border-background-200 bg-background-50/95 backdrop-blur-md'
          : 'border-b border-transparent bg-transparent'
      }`}
    >
      <nav className="mx-auto flex h-[68px] w-full max-w-[1200px] items-center justify-between px-4 md:px-8">
        <a
          href="#top"
          className="flex items-center gap-2 font-heading text-lg md:text-xl font-black tracking-wide"
        >
          <span
            className={`flex h-8 w-8 items-center justify-center rounded-md ${
              scrolled || menuOpen ? 'bg-primary-600 text-background-50' : 'bg-accent-500 text-foreground-950'
            }`}
          >
            <i className="ri-film-line text-lg" aria-hidden="true" />
          </span>
          <span className={scrolled || menuOpen ? 'text-foreground-950' : 'text-background-50'}>神马电影</span>
        </a>

        <ul className="hidden items-center gap-6 lg:flex">
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                className={`font-label text-sm font-medium transition-colors duration-200 ${
                  scrolled
                    ? 'text-foreground-700 hover:text-primary-600'
                    : 'text-background-100 hover:text-accent-300'
                }`}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <a
          href="#ranking"
          className={`hidden whitespace-nowrap rounded-md px-4 py-2 font-label text-sm font-semibold transition-colors duration-200 lg:inline-flex ${
            scrolled
              ? 'bg-primary-600 text-background-50 hover:bg-primary-700'
              : 'bg-background-50 text-foreground-950 hover:bg-accent-300'
          }`}
        >
          立即找片
        </a>

        <button
          type="button"
          onClick={() => setMenuOpen((prev) => !prev)}
          aria-label={menuOpen ? '关闭菜单' : '打开菜单'}
          aria-expanded={menuOpen}
          className={`flex h-10 w-10 items-center justify-center rounded-md border lg:hidden ${
            scrolled || menuOpen
              ? 'border-background-300 text-foreground-900'
              : 'border-background-50/40 text-background-50'
          }`}
        >
          <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} aria-hidden="true" />
        </button>
      </nav>

      {menuOpen ? (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <ul className="mx-auto flex w-full max-w-[1200px] flex-col px-4 py-2 md:px-8">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={() => setMenuOpen(false)}
                  className="block border-b border-background-100 py-3 font-label text-sm font-medium text-foreground-700 hover:text-primary-600"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </header>
  );
}